<template>
  <friendly-captcha
    ref="widget"
    :sitekey="siteKey"
    @complete="handleComplete"
    @expired="invalidate"
    @reset="invalidate"
    @error="invalidate"
  />
</template>

<script>
  export default {
    name: "FriendlyCaptchaField",
    props: {
      modelValue: {
        type: String,
        default: null
      }
    },
    emits: ['update:modelValue'],
    data: function() {
      return {
        siteKey: process.env.VUE_APP_FRIENDLY_CAPTCHA_SITE_KEY
      };
    },
    methods: {
      handleComplete(response) {
        const isValid = Boolean(response) && Boolean(this.$refs.widget.isValid());
        this.$emit('update:modelValue', isValid ? response : null);
      },
      invalidate() {
        this.$emit('update:modelValue', null);
      },
      reset() {
        this.invalidate();
        this.$refs.widget.reset();
      },
      isValid() {
        return Boolean(this.modelValue) && Boolean(this.$refs.widget.isValid());
      }
    }
  };
</script>
